export default __webpack_public_path__ + "static/media/cross.d8e705ac.svg";